import React, { useState, useEffect } from 'react'
import { Modal, Input } from 'antd'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { sendSalesOrPurchaseData } from 'src/features/WeeklySalesSlice'
import dayjs from 'dayjs'

const { TextArea } = Input

const NotesModal = ({
  visibleNotesModal,
  setVisibleNotesModal,
  date,
  existingNote,
  dateRange,
}) => {
  const [notes, setNotes] = useState('')
  const venueId = useSelector(state => state.venue?.venue?._id)
  const dispatch = useDispatch()

  useEffect(() => {
    if (visibleNotesModal) {
      setNotes(existingNote || '')
    }
  }, [visibleNotesModal, existingNote])

  const handleSave = async () => {
    const body = {
      date: dayjs(date).format('YYYY-MM-DD'),
      notes: notes.trim() || null,
    }
    dispatch(sendSalesOrPurchaseData(venueId, body, dateRange))
    setVisibleNotesModal(false)
  }

  const handleCancel = () => {
    setVisibleNotesModal(false)
    setNotes(existingNote || '')
  }

  const characterCount = notes.length
  const maxLength = 300

  return (
    <Modal
      width={'40%'}
      title={existingNote ? 'Edit Note' : 'Add Note'}
      okText={'Save'}
      visible={visibleNotesModal}
      onOk={handleSave}
      onCancel={handleCancel}
    >
      <NotesWrapper>
        <TextArea
          rows={6}
          placeholder='Enter note (max 300 characters)'
          value={notes}
          onChange={event => {
            const value = event.target.value
            if (value.length <= maxLength) {
              setNotes(value)
            }
          }}
          maxLength={maxLength}
          showCount
        />
        <CharacterCount>
          {characterCount} / {maxLength} characters
        </CharacterCount>
      </NotesWrapper>
    </Modal>
  )
}

const NotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const CharacterCount = styled.div`
  font-size: 12px;
  color: #8c8c8c;
  text-align: right;
`

export default NotesModal
